import { cn } from "@/modules/lib/utils"
import { SettingsIcon } from "@images/svgIcons/boxAdmin/settingsIcon"

type BoxSettingsSideCardProps = {} & React.ComponentProps<"div">

export function BoxSettingsSideCard({ className, ...props }: BoxSettingsSideCardProps) {
  return (
    <div
      className={cn(
        "mb-0 hidden w-full flex-col items-center gap-4 rounded-2xl bg-neutral-50 p-8 xl:flex xl:w-4/12",
        className,
      )}
      {...props}
    >
      <SettingsIcon color="currentColor" />
    </div>
  )
}
